$(() => {
    initInputs();
});
  
export function initInputs() {
  const inputsErrorMessages = $(".eui-input-error-message");
  const inputs = $(".eui-input");

  inputs.each((i, input) => {
    const isReadonly = $(input).is("[readonly]") && !$(input).parent().parent().hasClass('eui-input-content-datepicker');
    const isDropdown = $(input)
      .parent()
      .parent()
      .parent()
      .hasClass("eui-dropdown");

    if (isReadonly && !isDropdown) {
      $(input).addClass("eui-input--readonly");
      $(input).parent().parent().addClass("eui-input-content--readonly");
    }

    $(input).on("change", (event) => {
      const value = $(event.target).val();
      if (value != "" && !isReadonly) {
        event.target.parentElement?.parentElement?.classList.add(
          "eui-input-content--filled"
        );
      } else {
        event.target.parentElement?.parentElement?.classList.remove(
          "eui-input-content--filled"
        );
      }
    });

    const isPasswordInput = $(input).attr("type") === "password";
    if (isPasswordInput) {
      checkPasswordInput(input);
    }
  });

  inputsErrorMessages.each((_, input) => {
    checkIfInputHasErrorToShow(input);

    const observer = new MutationObserver(() =>
      checkIfInputHasErrorToShow(input)
    );
    observer.observe(input, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  });
}

function checkPasswordInput(input: HTMLElement) {
  const inputWrapper = $(input).parent();
  $("button", inputWrapper).on("click", (event) => {
    const type = $(input).attr("type");
    $(input).attr("type", type === "password" ? "text" : "password");

    if (type === "password") {
      $($(".eui-input-icon span", inputWrapper)[0]).addClass("eui-d-none");
      $($(".eui-input-icon span", inputWrapper)[1]).removeClass("eui-d-none");
    } else {
      $($(".eui-input-icon span", inputWrapper)[0]).removeClass("eui-d-none");
      $($(".eui-input-icon span", inputWrapper)[1]).addClass("eui-d-none");
    }
  });
}

function checkIfInputHasErrorToShow(input: HTMLElement) {
  const inputValidationError = $(".field-validation-error", input);
  const inputContent = $(input).parent();
  if (inputValidationError.length === 1) {
    $(inputContent).addClass("eui-input-content--error");
    $(".eui-input-wrapper", inputContent).addClass("eui-input-wrapper--error");
    $(".eui-input", inputContent).addClass("eui-input--error");
    $(input).removeClass("eui-d-none");
  } else {
    $(inputContent).removeClass("eui-input-content--error");
    $(".eui-input-wrapper", inputContent).removeClass(
      "eui-input-wrapper--error"
    );
    $(".eui-input", inputContent).removeClass("eui-input--error");
    $(input).addClass("eui-d-none");
  }
}

export function disableInput(input: HTMLInputElement) {
  const inputContent = $(input).parent().parent();
  const inputWrapper = $(input).parent();
  const inputErrorMessage = $(inputContent).find('.eui-input-error-message');

  $(inputContent).removeClass("eui-input-content--error");
  $(inputWrapper).removeClass("eui-input-wrapper--error")
  $(input).removeClass('eui-input--error');

  $(inputContent).addClass('eui-input-content--disabled');
  $(inputWrapper).addClass('eui-input-wrapper--disabled');
  $(input).addClass("eui-cursor-not-allowed");
  $(inputErrorMessage).addClass("eui-d-none");
}

export function enableInput(input: HTMLInputElement) {
  const inputContent = $(input).parent().parent();
  const inputWrapper = $(input).parent();

  $(inputContent).removeClass('eui-input-content--disabled');
  $(inputWrapper).removeClass('eui-input-wrapper--disabled');
  $(input).removeClass("eui-cursor-not-allowed");
}